export default __webpack_public_path__ + "static/manUnt-1e09bd756efcc844b546bef62e2bd53c.webp";